import { render, staticRenderFns } from "./temp-title.vue?vue&type=template&id=2f5df87c&scoped=true"
import script from "./temp-title.vue?vue&type=script&lang=js"
export * from "./temp-title.vue?vue&type=script&lang=js"
import style0 from "./temp-title.vue?vue&type=style&index=0&id=2f5df87c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5df87c",
  null
  
)

export default component.exports